<script>
  import WebFont from 'webfontloader'
  import { onMount, afterUpdate } from 'svelte'
  import { handleUpsell } from '../modules/helpers'
  import { text_entered, text_previewed, text_caseapplied, 
           preview_mode, previews_are_highlighted, previews_nav_filters,
           previews_font_size, previews_tracking, default_preview_width, 
           previews_storefronts_filter, previews_leading} from './../stores.js'
  import { createEventDispatcher } from 'svelte'
  
  const dispatch = createEventDispatcher()
  export let font
  export let zoomed
  
  let element
  let wrapper_element
  let hovering = false
  let mounted = false
  let fallback_font = 'Raleway Dots'
  let zoomed_font_scale = 1
  const availableW = window.innerWidth - 400
  const availableH = window.innerHeight - 400
  
  $: zoomed && scaleUp()
  $: !zoomed && undoScaleUp()
  
  onMount(() => {
    mounted = true
    loadGoogleFont()
    return () => {
      mounted = false
    }
  })

  afterUpdate(() => {
    if(!font.font_file_loaded) loadGoogleFont()
  })
  
  function getTextSelection(e) {
    if(zoomed) return
    if(!!$previews_storefronts_filter) return
    let sObj = window.getSelection()
    if (!font.zoomed_text && (sObj.toString() !== "") && (sObj.toString() !== $text_caseapplied) && (e.target === element)) {
      handleTextSelection(sObj)
    } else {
      dispatch('handleClick')
      return false
    }
  }

  function handleTextSelection(sObj) {
    handleUpsell('highlight')
    let pre = $text_caseapplied.substring(0, sObj.getRangeAt(0).startOffset)
    var sel = $text_caseapplied.substring(sObj.getRangeAt(0).startOffset, sObj.getRangeAt(0).endOffset)
    var post = $text_caseapplied.substring(sObj.getRangeAt(0).endOffset, sObj.length)
    $text_previewed = pre + "<span class='highlight'>" + sel + "</span>" + post
    $previews_are_highlighted = true
  }

  function scaleUp() {
    while(element.getBoundingClientRect().width < availableW && element.getBoundingClientRect().height < availableH) {
      zoomed_font_scale += 0.1
      applyZoomedFontScale()
    }
    zoomed_font_scale -= 0.1
    applyZoomedFontScale()
  }
  function scaleDown() {
    while(element.getBoundingClientRect().width > availableW || element.getBoundingClientRect().height > availableH) {
      zoomed_font_scale -= 0.1
      applyZoomedFontScale()
    }
  }

  function undoScaleUp() {
    if (!mounted) return
    zoomed_font_scale = 1
    element.style.removeProperty('transform')
  }

  function applyZoomedFontScale(size) {
    if (size) {
      zoomed_font_scale = size
    }
    element.style.transform = "scale("+zoomed_font_scale+")"
  }

  function loadGoogleFont() {
    if (font.source === 'google' && !font.font_file_loaded) {
      WebFont.load({
        google: {
          families: [font.loadurl],
          // text: $text_entered
        },
        fontactive: function(fontFamily, fontDescription) {
          font.font_file_loaded = true
        },
        fontinactive: function(fontFamily, fontDescription) {
          console.log('fontinactive: ' + fontFamily + ' (' + fontDescription + ')')
          dispatch('fontinactive')
        },
        classes: false
      })
      // TODO Why doesn't this send the font object alongwith update? Fixed?
      dispatch('updateFont', font)
    }
  }

  function handleMouseOver() {
    if (zoomed) return
    hovering = true
  }
  function handleMouseOut() {
    if (zoomed) return
    hovering = false
  }
  function handleKeyup() {
    scaleDown()
  }

  $: cannot_display = wrapper_element ? wrapper_element.getBoundingClientRect().width === $default_preview_width ? true : false : ''

</script>

  
<div class="outer" bind:this={wrapper_element}>
  <div
    class="inner" 
    bind:this = {element}
    class:highlighted = {$previews_are_highlighted && !hovering}
    class:zoomed
    class:cannot_display
    class:paragraph = {$preview_mode === 'paragraphs'}
    class:selectable = {!zoomed && !$previews_nav_filters.selected && !$previews_storefronts_filter}
    contenteditable = {zoomed}
    spellcheck = "false"
    on:mouseover = {() => handleMouseOver}
    on:mouseout = {() => handleMouseOut}
    on:mouseup = {(e) => getTextSelection(e)}
    on:keydown = {handleKeyup}
    on:keyup = {handleKeyup}
    style="
      line-height: {$previews_leading}em;
      font-family: {'"'+font.postscript_name+'"'}, {'"'+font.family_name+'"'}, {fallback_font}, cursive; 
      letter-spacing:{Math.sign($previews_tracking) * Math.pow(1.25, Math.abs($previews_tracking)) * 0.025}em;
      {font.style ? ('font-style:' + font.style + ';') : ''}
      {font.weight ? ('font-weight:' + font.weight + ';') : ''}
      {font.stretch ? ('font-stretch:' + font.stretch + ';') : ''}
      transform:scale({zoomed_font_scale})
      "
    >
    {#if hovering}
      {#if $text_caseapplied !== $text_entered}
        {@html $text_caseapplied}
      {:else}
        {@html $text_entered}
      {/if}
    {:else}
      {@html $text_previewed}
    {/if}
  </div>
</div>

<style>
  .inner {
    /* line-height: 5rem; */
    display: inline-block;
    white-space: pre-line;
    transition-property: opacity, color;
    transition-duration: var(--transition-duration);
    transition-timing-function: var(--transition-function);
  }

  .inner.zoomed {
    /* line-height: 1.4em !important; */
    outline: none;
  }

  .inner.selectable {
    cursor: text;
  }
  
  .highlighted {
    color: var(--c-text-faded-big);
    font-variant-ligatures: none;
  }
  .highlighted :global(.highlight) {
    color: var(--c-text);
  }

  .paragraph {
    padding-bottom: 6.5rem !important;
    max-width: 22em;
    text-align: left;
  }
  .cannot_display {
    color: var(--c-text-faded);
  }

</style>